<div class="tnc-container-parent">
  <div class="tnc-container">
    <h1>User Terms and Conditions</h1>

    <!--Disclosures here with a border-->
    <div class="tnc-disclosures">
      <p>Our Disclosures:</p>
      <br />
      <p>
        Our complete terms and conditions are contained below, but some important points for you to know before you
        become a participant are set out below:
      </p>
      <ul>
        <li>Our liability under these terms is limited as set out in clause</li>
        <li>
          If you participate in a Campaign, you must be satisfied with the Campaign details (including the terms and
          conditions associated with the Campaign) and the Host prior to participating in the Campaign, including that
          the Campaign is compliant with the relevant laws of your jurisdiction.
        </li>
        <li>
          Where you are sharing an event ticket with a third party, you must only disclose the third party’s personal
          information (such as their name and email address) to us if you have the right to do so.
        </li>
      </ul>
      <p>Nothing in these terms limit your rights under the Australian Consumer Law.</p>
    </div>

    <!--Terms and Conditions here-->
    <ol>
      <li>
        Introduction
        <ol type="a">
          <li>
            This website (Site) is operated by GalaBid Pty Ltd (ACN 150 269 720) (we, our or us), where we facilitate
            access to a range of fundraising and campaigns, products and experiences for you to bid on, raffles to
            participate in and events for you to purchase tickets to, and share and manage guest lists for (together a
            Campaign). These terms and conditions (Terms) are between us and you, the person participating in the
            Campaign.
          </li>
          <li>
            We only provide our Services and are not a party to any transaction between you and a Host in relation to
            any Campaign.
          </li>
          <li>
            We may, at any time (at our sole discretion), remove any Campaigns, including where a Campaign:
            <ol type="1">
              <li>is illegal or offensive; or</li>
              <li>contains graphic, inappropriate or unlawful content.</li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        Disclaimer
        <ol type="a">
          <li>
            Our Site is a place where you can find Hosts and their Campaigns. You can participate in Campaigns by making
            Payments, purchasing raffle tickets, purchasing event tickets, or placing bids in an auction.
          </li>
          <li>
            We do not verify or endorse the legitimacy, lawfulness or accuracy of any of the Campaigns or the third
            party hosting the Campaign (Host) on our Site. You acknowledge that it is your responsibility to assess and
            check the Campaign and Host prior to participating in the Campaign. You must be satisfied with the Host, the
            Campaign details, including that the Campaign complies with the applicable laws of your jurisdiction, and
            the intended use of your charitable funds before making any payments.
          </li>
          <li>
            Hosts may include terms and conditions relating to their Campaign. By making Payment to a Campaign, you
            accept the additional terms and conditions in the Campaign.
          </li>
          <li>We may receive a financial benefit from the Host for displaying their Campaign.</li>
        </ol>
      </li>
      <li>
        Use of the Site
        <ol type="a">
          <li>
            You accept these Terms by creating an account on the Site. Subject to your compliance with these Terms, we
            will provide you with access to our Site (Services). We will not be responsible for any other services
            unless expressly set out on in these Terms.
          </li>
          <li>
            You must not use the Site and/or participate in Campaigns through the Site unless you are at least 18 years
            old.
          </li>
          <li>
            When using the Site, you must not do or attempt to do anything that is unlawful or inappropriate, including:
            <ol type="1">
              <li>
                anything that would constitute a breach of an individual’s privacy (including uploading private or
                personal information without an individual's consent) or any other legal rights;
              </li>
              <li>using the Site to defame, harass, threaten, menace or offend any person;</li>
              <li>using the Site for unlawful purposes;</li>
              <li>interfering with any user of the Site;</li>
              <li>tampering with or modifying the Site (including by transmitting viruses and using trojan horses);</li>
              <li>using the Site to send unsolicited electronic messages;</li>
              <li>
                using data mining, robots, screen scraping or similar data gathering and extraction tools on the Site;
              </li>
              <li>facilitating or assisting a third party to do any of the above acts; or</li>
              <li>
                participating in Campaigns, such as raffles, which do not comply with the applicable laws of your
                jurisdiction.
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        Accounts
        <ol type="a">
          <li>You may participate in Campaigns through an account with us.</li>
          <li>
            You must ensure that any personal information you give to us when creating an account is accurate and
            up-to-date. All personal information that you give to us will be treated in accordance with our Privacy
            Policy available at:
            <a href="https://www.galabid.com/global-privacy-policy" target="_blank"
              >https://www.galabid.com/global-privacy-policy</a
            >.
          </li>
          <li>
            It is your responsibility to keep your account details confidential. You are responsible for all activity on
            your account, including purchases made using your account details.
          </li>
        </ol>
      </li>
      <li>
        Campaigns
        <ol type="a">
          <li>
            You may participate in Campaigns as set out on the Site. If you make a payment, purchase a raffle ticket,
            purchase an event ticket or place a bid in an auction on our Site, you are participating in a Campaign.
          </li>
          <li>
            You acknowledge and agree that we facilitate the fundraising process between you and Host. Payments are
            processed by a third party payment provider (Stripe), as set out in clause 6.1(d).
          </li>
          <li>
            We do not verify the details of any Campaign or Host. It is your responsibility to check the Campaign
            details and the Host, including that the Host is licensed to conduct the Campaign, the terms and conditions
            uploaded by the Host for the Campaign, delivery details, refund policies and pricing (if applicable), before
            you participate in the Campaign through the Site. You acknowledge and agree that you must be satisfied with
            the Host and the Hosts’ Campaign prior to participating.
          </li>
        </ol>
      </li>
      <li>
        Price and payments
        <ol type="a">
          <li>
            You must pay the Host for items purchased, items won in an auction and donations made, plus any applicable
            delivery costs as set out on the Site (the Price) in accordance with this clause. Unless stated otherwise on
            the Campaign, the Price set out for the Campaign shall be exclusive of any tax imposed by any government,
            state or local authority on the value of goods and services, and includes goods and services tax, sales tax,
            use tax, indirect tax, value added tax, excise tax, customs tax, tariffs and duties (Tax), which will be
            your responsibility to pay.
          </li>
          <li>
            Prior to placing a bid or making a Payment to a Campaign, you may be required to enter card details to
            preauthorize payment. You acknowledge and agree that the Host may charge your preauthorized card for any
            outstanding invoices once the Campaign has closed.
          </li>
          <li>
            You must not pay, or attempt to pay, the Price by fraudulent or unlawful means. If you make a payment by
            debit card or credit card, you warrant that you are authorized to use the debit card or credit card to make
            the payment.
          </li>
          <li>
            Payments can be made to the Host via our Site using an integrated third party provider, Stripe. You
            acknowledge and agree that we have no control over the actions of the third-party provider, and your use of
            the third-party payment method may be subject to additional terms and conditions.
          </li>
          <li>
            Any online payments you make on a Campaign will be distributed by Stripe to the Host’s Stripe account. We do
            not receive or hold any funds paid to a Campaign.
          </li>
        </ol>
      </li>
      <li>
        Delivery
        <ol type="a">
          <li>
            You acknowledge and agree that we are not responsible for the delivery or fulfillment of any prizes, tickets
            or any other item offered by a Host through a Campaign. Delivery and fulfillment of such prizes, tickets or
            other rewards is the sole responsibility of the respective Host. If a Host has chosen to use an item
            supplied by us, you acknowledge that any terms and conditions associated with the item are set out in the
            Campaign.
          </li>
          <li>
            By participating in a Campaign, you acknowledge that there is a separate agreement with the Host governing
            the delivery and fulfillment of prizes and tickets.
          </li>
        </ol>
      </li>
      <li>
        Cancellations and Refunds
        <ol type="a">
          <li>
            The cancellation and refund of any amounts paid in respect of a Campaign is strictly a matter between you
            and the Host. The terms and conditions of a Campaign should set out whether refunds or cancellations are
            permitted.
          </li>
          <li>
            You acknowledge and agree that the Host is solely responsible for providing any refund to you. If you have
            any queries or requests regarding a return or refund, you must contact the Host.
          </li>
        </ol>
      </li>
      <li>
        Limitations
        <ol type="a">
          <li>
            Despite anything to the contrary, but subject to your Consumer Law Rights, to the maximum extent permitted
            by law:
            <ol type="1">
              <li>neither Party will be liable for Consequential Loss;</li>
              <li>
                each Party’s liability for any Liability under these Terms will be reduced proportionately to the extent
                the relevant Liability was caused or contributed to by the acts or omissions of the other Party,
                including any failure by that Party to mitigate its losses; and
              </li>
              <li>
                our aggregate liability for any Liability arising from or in connection with the Terms (including the
                products and/or the subject matter of the Terms) will be limited to, and must not exceed, $1000.
              </li>
            </ol>
          </li>
          <li>
            To the maximum extent permitted by law, we will not be liable for, and you release us from liability for,
            any Liability caused or contributed to by, arising from or in connection with:
            <ol type="1">
              <li>any aspect of the interactions between you and the Host, including in relation to any Campaigns;</li>
              <li>
                your computing environment (for example, your hardware, software, information technology and
                telecommunications services and systems); or
              </li>
              <li>any event outside of our reasonable control.</li>
            </ol>
          </li>
          <li>
            Where you are a consumer, our goods and services come with guarantees that cannot be excluded under the
            Australian Consumer Law. Nothing in these Terms purports to modify or exclude the conditions, warranties and
            undertakings, and other legal rights, under the Australian Competition and Consumer Act 2010 (Cth) and any
            other law intended to protect consumers in any jurisdiction outside of Australia (Consumer Law Rights). Any
            and all other warranties or conditions which are not guaranteed by Consumer Law Rights are expressly
            excluded where permitted, except to the extent such warranties and conditions are fully expressed in these
            Terms.
          </li>
        </ol>
      </li>
      <li>
        Intellectual property
        <ol type="a">
          <li>
            Our Intellectual Property
            <ol>
              <li>
                You acknowledge and agree that any intellectual property (including copyright and trademarks) developed,
                adapted, modified or created by us or our personnel (including in connection with the Terms, any content
                on the Site, and the products) (Our Intellectual Property) will at all times vest, or remain vested, in
                us.
              </li>
              <li>
                We authorise you to use Our Intellectual Property solely for your own personal, non-commercial use, and
                in the manner in which it was intended to be used.
              </li>
              <li>
                You must not use Our Intellectual Property for commercial purposes, including, for example, to advertise
                your own business, for re-sale, or for any other revenue generation activity.
              </li>
              <li>
                You must not, without our prior written consent:
                <ol>
                  <li>copy, in whole or in part, any of Our Intellectual Property;</li>
                  <li>
                    reproduce, retransmit, distribute, disseminate, sell, publish, broadcast or circulate any of Our
                    Intellectual Property to any third party; or
                  </li>
                  <li>
                    breach any intellectual property rights connected with the Site or the products, including (without
                    limitation) altering or modifying any of Our Intellectual Property; causing any of Our Intellectual
                    Property to be framed or embedded in another website; or creating derivative works from any of Our
                    Intellectual Property.
                  </li>
                </ol>
              </li>
              <li>
                Nothing in the above clause restricts your ability to publish, post or repost Our Intellectual Property
                on your social media page or blog, provided that:
                <ol>
                  <li>you do not assert that you are the owner of Our Intellectual Property;</li>
                  <li>
                    unless explicitly agreed by us in writing, you do not assert that you are endorsed or approved by
                    us;
                  </li>
                  <li>
                    you do not damage or take advantage of our reputation, including in a manner that is illegal,
                    unfair, misleading or deceptive; and
                  </li>
                  <li>you comply with all other terms of these Terms.</li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            The Host's Intellectual Property
            <ol>
              <li>
                You acknowledge and agree that any intellectual property (including copyright and trademarks) developed,
                adapted, modified or created by the Host or the Host's personnel (including in connection with a
                Campaign, any terms and conditions associated with the Campaign, and the products related to the
                Campaign) (Host's Intellectual Property) will at all times vest, or remain vested, in the Host.
              </li>
              <li>
                You must not use the Host's Intellectual Property for commercial purposes, including, for example, to
                advertise your own business, for re-sale, or for any other revenue generation activity.
              </li>
              <li>
                You must not, without the Host's prior written consent:
                <ol>
                  <li>copy, in whole or in part, any of the Host's Intellectual Property; or</li>
                  <li>
                    reproduce, retransmit, distribute, disseminate, sell, publish, broadcast or circulate any of the
                    Host's Intellectual Property to any third party.
                  </li>
                </ol>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        User Content
        <ol type="a">
          <li>
            You may be permitted to post, upload, publish, submit or transmit relevant information and content (User
            Content) on the Site.
          </li>
          <li>
            If you purchased an event ticket and intend to share the event ticket with a third party, you acknowledge
            and agree that you will only share the personal information of a third party to us if you have the right to
            do so (such as having the third party's express consent).
          </li>
          <li>
            If you make any User Content available on or through the Site, you grant to us a worldwide, irrevocable,
            perpetual, non-exclusive, transferable, royalty-free licence to use the User Content, with the right to use,
            view, copy, adapt, modify, distribute, license, transfer, communicate, publicly display, publicly perform,
            transmit, stream, broadcast, access, or otherwise exploit such User Content on, through or by means of the
            Site and our social media platforms.
          </li>
          <li>
            You agree that you are solely responsible for all User Content that you make available on or through the
            Site. You represent and warrant that:
            <ol>
              <li>
                you are either the sole and exclusive owner of all User Content or you have all rights, licences,
                consents and releases that are necessary to grant to us the rights in such User Content (as contemplated
                by these Terms); and
              </li>
              <li>
                neither the User Content nor the posting, uploading, publication, submission or transmission of the User
                Content or our use of the User Content on, through or by means of our Site (including on social media)
                will infringe, misappropriate or violate a third party's intellectual property rights, or rights of
                publicity or privacy, or result in the violation of any applicable law or regulation.
              </li>
            </ol>
          </li>
          <li>
            We do not endorse or approve, and are not responsible for, any User Content. We may, at any time (at our
            sole discretion), remove any User Content.
          </li>
        </ol>
      </li>
      <li>
        Availability, Disruption and Downtime
        <ol type="a">
          <li>
            While we strive to always make the Site available to you, we do not make any promises that it will be
            available 100% of the time. The Site may be disrupted during certain periods, including, for example, as a
            result of scheduled or emergency maintenance.
          </li>
          <li>
            The Site may interact with, or be reliant on, products or services provided by third parties, such as cloud
            hosting service providers. To the maximum extent permitted by law, we are not liable for disruptions or
            downtime caused or contributed to by these third parties.
          </li>
          <li>
            We will try to provide you with reasonable notice, where possible, of any disruptions to your access to the
            Site.
          </li>
        </ol>
      </li>
      <li>
        Personal Information
        <ol type="a">
          <li>
            We collect, hold and disclose and use any Personal Information you provide to us in accordance with our
            <a href="https://www.galabid.com/global-privacy-policy" target="_blank">privacy policy</a>, available on our
            website, and applicable privacy laws.
          </li>
          <li>
            You must only disclose Personal Information to us if you have the right to do so (such as having the
            individual's express consent).
          </li>
        </ol>
      </li>
      <li>
        General
        <ol type="a">
          <li>
            <b>Disputes between Hosts and you</b>: We encourage Hosts and you to attempt to resolve disputes (including
            claims for refunds or remedies) directly and in good faith, either through our Site or through external
            communication methods. In the event that a dispute cannot be resolved through these means, Hosts and you may
            choose to resolve the dispute through other means, such as mediation. We are not responsible for mediating
            or resolving disputes between Hosts and you.
          </li>
          <li>
            <b>Disputes with GalaBid</b>: A Party may not commence court proceedings relating to a dispute without first
            meeting with the other Party to seek (in good faith) to resolve the dispute, failing which the Parties agree
            to engage a mediator to attempt to resolve the dispute. The costs of the mediation will be shared equally
            between the Parties. Nothing in this clause will operate to prevent a Party from seeking urgent injunctive
            or equitable relief from a court of appropriate jurisdiction. If the Dispute is not resolved at that initial
            meeting:
            <ol>
              <li>
                where you are resident or incorporated in Australia, refer the matter to mediation, administered by the
                Australian Disputes Centre in accordance with Australian Disputes Centre Guidelines for Commercial
                Mediation; or
              </li>
              <li>
                where you are not resident or incorporated in Australia, refer the matter to arbitration administered by
                the Australian Centre for International Commercial Arbitration, with such arbitration to be conducted in
                Sydney, New South Wales, before one arbitrator, in English and in accordance with the ACICA Arbitration
                Rules.
              </li>
            </ol>
          </li>
          <li>
            <b>Notices</b>: Any notice given under these Terms must be in writing addressed to us at the details set out
            below or to you at the details provided when you submitted your order or in your account. Any notice may be
            sent by standard post or email, and will be deemed to have been served on the expiry of 48 hours in the case
            of post, or at the time of transmission in the case of transmission by email.
          </li>
          <li>
            <b>Force Majeure</b>: Neither Party will be liable for any delay or failure to perform their respective
            obligations under these Terms if such delay or failure is caused or contributed to by a Force Majeure Event,
            provided the Party seeking to rely on the benefit of this clause, as soon as reasonably practical, notified
            the other Party in writing about the Force Majeure Event and the extent to which it is unable to perform its
            obligations and uses reasonable endeavours to minimise the duration and adverse consequences of the Force
            Majeure Event.
          </li>
          <li>
            <b>Illegal Requests</b>: We reserve the right to refuse any request for or in relation to our Services that
            we deem inappropriate, unethical, unreasonable, illegal or otherwise non-compliant with these Terms.
          </li>
          <li>
            <b>Feedback and complaints</b>: We are always looking to improve our services. If you have any feedback or a
            complaint, please notify us on our contact details below and we will take reasonable steps to address any
            concerns you have.
          </li>
          <li>
            <b>Assignment</b>: You must not assign any rights or obligations under these Terms, whether in whole or in
            part, without our prior written consent.
          </li>
          <li>
            <b>Amendment</b>: We may, at any time and at our discretion, vary these Terms by publishing varied terms on
            the Site. Prior to placing an order, we recommend you carefully read the terms that are in effect at that
            time to ensure you understand and agree to them.
          </li>
          <li>
            <b>Governing law</b>: These Terms are governed by the laws of New South Wales. Each Party irrevocably and
            unconditionally submits to the exclusive jurisdiction of the courts operating in New South Wales and any
            courts entitled to hear appeals from those courts and waives any right to object to proceedings being
            brought in those courts.
          </li>
          <li>
            <b>Third party sites</b>: The Site may contain links to websites operated by third parties. Unless we tell
            you otherwise, we do not control, endorse or approve, and are not responsible for, the content on those
            websites. We recommend that you make your own investigations with respect to the suitability of those
            websites. If you purchase goods or services from a third party website linked from the Site, such third
            party provides the goods and services to you, not us. We may receive a benefit (which may include a referral
            fee or a commission) should you visit certain third-party websites via a link on the Site (Affiliate Link)
            or for featuring certain products or services on the Site. We will make it clear by notice to you which (if
            any) products or services we receive a benefit to feature on the Site, or which (if any) third party links
            are Affiliate Links.
          </li>
        </ol>
      </li>
      <li>
        Definitions
        <ol type="a">
          <li>
            <b>Consequential Loss</b> means, whether under statute, contract, equity, tort (including negligence),
            indemnity or otherwise; any loss or damage that cannot be considered to arise according to the usual course
            of things from the relevant breach, act or omission, whether or not such loss or damage may reasonably be
            supposed to have been in the contemplation of the Parties at the time they entered into these Terms as the
            probably results of the relevant breach, act or omission, and/or, any real or anticipated loss of profit,
            loss of benefit, loss of revenue, loss of business, loss of goodwill loss of opportunity, loss of savings,
            loss of reputation, loss of use and/or loss or corruption of data. The Parties agree that your obligation to
            pay us the Price under these Terms will not constitute "Consequential Loss".
          </li>
          <li>
            <b>Force Majeure</b> Event means any event or circumstance which is beyond a Party's reasonable control.
          </li>
          <li>
            <b>Liability</b> means any expense, cost, liability, loss, damage, claim, notice, entitlement,
            investigation, demand, proceeding or judgement (whether under statute, contract, equity, tort (including
            negligence), indemnity or otherwise), howsoever arising, whether direct or indirect and/or whether present,
            unascertained, future or contingent and whether involving a third party or a party to these Terms or
            otherwise.
          </li>
          <li>
            <b>Payment</b> means any transaction you make (such as making a payment for an item won in an auction) on
            the Platform.
          </li>
          <li>
            <b>Personal Information</b> means any information or opinion about an identified individual, or an
            individual who is reasonably identifiable, whether the information or opinion is true or not, and whether
            the information or opinion is recorded in a tangible form or not.
          </li>
          <li><b>Services</b> means access to our Site, as detailed in clause 3.1(a).</li>
        </ol>
      </li>
    </ol>

    <b>For any questions and notices, please contact us at:</b>
    <b>GalaBid Pty Ltd (ACN 150 269 720)</b>
    <p>Email: helpdesk&#64;galabid.com</p>
    <b>© <a href="https://www.legalvision.com.au/" target="_blank">LegalVision</a> ILP Pty Ltd</b>
  </div>
</div>
